<template>
    <div class="content">
        <w-navbar
            :icon="'iconchevron-left'"
            :cvShow="true"
            :nav_title="'我答过的题'"
            :right_btn_html="sortText"
            @mobileLeftBtn="pageBack"
        />
        <div class="list" v-if="list.length>0">
            <div class="list-item" v-for="(item,index) in list" :key="item.token" @click="toDetail(item,index)">
                <div >
                    <div style="display:flex"><div class="title">{{index+1}}</div><div class="main">{{item.question_title}}</div></div>
                    
                    <div style="display:flex;margin-top:10px;" v-if="type!='custom'">
                        
                        <img src="./image/3.png" alt="" srcset="" class="img"><div class="num">{{item.question_template.user_count || ""}}人在做</div>
                        <img src="./image/17.png" alt="" srcset="" style="width:54px;height:13px;margin-right:12px;margin-left:12px;"  v-if="item.is_viewed">
                    </div>
                </div>
               <img src="./image/4.png" alt="" srcset="" style="width:10px;height:16px;">
            </div>
             
        </div>
        <w-no-results text="暂时没有内容" v-show="list.length===0"/>
    </div>
</template>

<script>
import WNavbar from "@/components/global/w-navbar";
import WPopup from "@/components/global/w-popup";
import { componentsMixin } from "../../assets/js/mixin/components";
import WNoResults from '../account/components/discuss-no-result'
export default {
    props: {
        state: {
            type: Boolean,
            default: false,
        },
        pageData: {
            type: Object,
            default: () => {
                return {};
            },
        },
        exportState: {
            type: Boolean,
            default: false,
        },
        // actionSheetState: {
        //     type: Boolean,
        //     default: true,
        // },
        actionSheetData: {
            type: Object,
            default: () => {
                return {};
            },
        },
        highlightIndex: {
            type: Number,
            default: 1,
        },
    },
    name: "job-alert",
    mixins: [componentsMixin],
    data() {
        return {
            list: [],
            navList:[{title:'预测题',type:'history'},{title:'收藏',type:'favorite'},{title:'自定义',type:'custom'}],
            type:'answered'
        };
    },
    mounted() {
        this.getQusList();
    },
    computed: {
        sortText() {
            return null;
        },
    },
    watch: {
    //     messageList() {
	// 	console.log("messageList change");
	// 	this.$nextTick(() => {
	// 		var h = $(".chat-list").innerHeight();
	// 		$(".chatbox").scrollTop(h);
	// 	})
	// }
    },
    components: {
        WNavbar,
        WPopup,
        WNoResults
    },
    updated:function(){
       
       
        
    },
    methods: {
        pageBack() {
            this.$router.back();
        },
       async getQusList(){
           console.log(this.$route.query.token)
            let res = await this.$api.hackathon.getMyList({'type': this.type });
            this.list = res.data;
        },
        toDetail(item,index){
            console.log(item,"item");
             this.$router.push({
                path:'/interview/answer?token='+item.token+'&cv_token='+this.$route.query.cv_token+'&&isEdit=true&&index='+index
            })
        },
        tab(item){
            this.list = [];
            this.type = item.type;
            this.getQusList();
        }
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/global/variable";
@import "@/assets/scss/global/mixin";
.nav-list{
    margin-top:58px;
    display: flex;
    margin-left: 30px;
    margin-right: 30px;
    justify-content: space-around;
    background: rgba(8, 21, 53, 0.05);
.nav-list-active{
    background: #fff;
    width: 33%;
    height: 30px;
    text-align: center;
    line-height: 30px;
}
.nav-list-item{
    width: 33%;
    height: 30px;
    text-align: center;
    line-height: 30px;
    color: rgba(156, 156, 156, 1);
}
}
.desc{
    background:rgba(255, 102, 68, 1);
    color: #fff;
    padding:36px 24px 24px 24px;
    margin-top: 44px;
    line-height: 24px;
    border-radius: 0px 0px 28px 28px;
}
.list{
    padding-left: 10px;padding-right: 10px ;
    margin-top: 50px;
.list-item{
    width: 100%;
    background-image: url("data:image/png;base64,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");
    background-size:100% 100% ;
    // height:100px;
    display: flex;
    justify-content:space-between;
    padding: 20px;
    padding-top: 30px;
    padding-left:30px;
    padding-bottom: 30px;
    padding-right: 30px;
    align-items: center;
    .main{
        font-size: 14px;
        color: rgba(64, 64, 64, 1);
        line-height: 20px;
        color:rgba(64, 64, 64, 1);
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 270px;
    }
    .title{
        font-size: 16px;
        font-weight: bold;
        color: #404040;
        margin-right:10px ;
    }
    .img{
        width:10px;
        height:12px;
        margin-right: 8px;
        margin-left: 20px;
    }
    .num{
        font-size: 12px;color: rgba(156, 156, 156, 1);
    }
}
}
</style>